import { createContext } from 'react';

export const ContextStore = createContext<ContextState | undefined>(undefined);
